// hooks/useWebSocket.js
import { useEffect, useRef, useState } from 'react';

export const useWebSocket = (url, onMessageCallback) => {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
      if(url){
        socketRef.current = new WebSocket(url);

        socketRef.current.onopen = () => {
          setIsConnected(true);
          console.log('WebSocket connected');
        };

        socketRef.current.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            onMessageCallback?.(data);
          } catch (err) {
            console.error('Error parsing message:', err);
          }
        };

        socketRef.current.onerror = (err) => {
          console.error('WebSocket error:', err);
        };

        socketRef.current.onclose = () => {
          setIsConnected(false);
          console.log('WebSocket closed');
        };
    }

    return () => {
      socketRef.current?.close();
    };
  }, [url]);

  return {
    sendMessage: (msg) => {
      if (isConnected && socketRef.current?.readyState === WebSocket.OPEN) {
        socketRef.current.send(JSON.stringify(msg));
      }
    },
    isConnected
  };
};
